





















































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, ProvideReactive, Watch } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { PanelDashboardUseCase } from '@/modules/dashboard/use-cases/panel/panel-dashboard.use-case'
import PanelLastCampaignTableRow from '@/modules/base-campaign/components/panel/PanelLastCampaignTableRow.vue'
import CtaButton from '@/modules/shared/components/shared/kit/CtaButton.vue'
import PanelContentItemTableRow from '@/modules/content-item/components/panel/table/PanelContentItemTableRow.vue'
import { getContentItemColumnsInPanel } from '@/modules/content-item/models/columns/content-item.column'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import DashboardCard, { DashboardCardItemModel } from '@/modules/dashboard/components/shared/DashboardCard.vue'
import { getLastCampaignsTableColumns } from '@/modules/base-campaign/models/columns/base-campaigns-table.column'
import { DashboardResourceType } from '@/modules/dashboard/models/panel-dashboard.model'
import TicketTableRow from '@/modules/ticket/components/shared/table/TicketTableRow.vue'
import { getTicketDashboardTableColumn } from '@/modules/ticket/models/columns/ticket-dashboard-table.column'
import TesTab from '@/modules/shared/components/shared/TesTab.vue'
import { CampaignTypes } from '@/modules/base-campaign/models/base-campaign-resource.model'
import NewTicketButton from '@/modules/ticket/components/shared/NewTicketButton.vue'
import { ContentItemCollectionModel } from '@/modules/content-item/models/content-item-collection.model'
import {
  BasicCampaignCollectionModel,
  BasicCampaignCollectionType
} from '@/modules/base-campaign/models/base-campaign-collection.model'
import {
  PanelContentItemGetItemsUseCase
} from '@/modules/content-item/use-cases/panel/panel-content-item-get-items-use.case'
import { DashboardStore } from '@/modules/dashboard/store/dashboard.store'
import UserPhoneVerificationModal
  from '@/modules/user/components/shared/phone-verification/UserPhoneVerificationModal.vue'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import InitialPropsStore from '@/modules/common/layout/store/initial-props.store'
import UserPhoneEditForm from '@/modules/user/components/shared/phone-verification/UserPhoneEditForm.vue'
import { PanelLayoutRoute } from '@/modules/common/layout/routes/panel-layout.route'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'داشبورد',
    page_sub_header: 'داشبورد کاربری شما لیست از ویجت ها برای دسترسی آسان تر به قسمت های کاربردی پنل',
    over_header_props: { showMessage: true }
  },
  metaInfo: {
    title: 'داشبورد'
  },
  components: {
    UserPhoneEditForm,
    UserPhoneVerificationModal,
    NewTicketButton,
    TesTab,
    DashboardCard,
    CtaButton,
    TesTable,
    BaseCard,
    BaseButton
  }
})
export default class Dashboard extends Vue {

  constructor(
    private readonly panelLayoutRoute: PanelLayoutRoute,
    private readonly dashboardUseCase: PanelDashboardUseCase,
    private readonly contentItemUseCase: PanelContentItemGetItemsUseCase,
    private readonly store: DashboardStore,
    private readonly userBootUseCase: UserBootUseCase,
    private readonly initialPropsStore: InitialPropsStore,
    private readonly contentCampaignRoutes: PanelContentCampaignRoute
  ) {
    super()
  }

  @Prop() dashboard_stats!: DashboardResourceType
  @Prop() campaigns_count: number

  private CampaignTypes = CampaignTypes
  contentItemData: ContentItemCollectionModel[] = []
  lastCampaignData: BasicCampaignCollectionModel[] = []

  private contentItemRow = PanelContentItemTableRow
  private lastCampaignRow = PanelLastCampaignTableRow
  private ticketRow = TicketTableRow

  @ProvideReactive()
  items = null
  @ProvideReactive()
  lastCampaigns: BasicCampaignCollectionType = null
  @ProvideReactive()
  tickets = { statuses: this.dashboard_stats.ticket_statuses }

  activeTab = CampaignTypes.CONTENT
  itemsLoading = false
  campaignsLoading = false

  //Mounted-----------------
  mounted() {
    this.setCampaignTable()
    this.allCampaigns()
  }

  get contentCardItems(): Array<DashboardCardItemModel> {
    return [
      {
        label: 'تولید شده',
        value: this.dashboard_stats.data.stats.content.completed || 0,
        icon: 'sparkles-outline',
        url: 'content/items?statuses[]=completed&page=1'

      },
      {
        label: 'در صف تولید محتوا',
        value: this.dashboard_stats.data.stats.content.queue || 0,
        icon: 'albums-outline',
        url: 'content/items?statuses[]=queue&page=1'
      },
      {
        label: 'در حال ویراستاری',
        value: this.dashboard_stats.data.stats.content.editing || 0,
        icon: 'clipboard-outline',
        url: 'content/items?statuses[]=editing&page=1'
      },
      {
        label: 'در انتظار بررسی',
        value: this.dashboard_stats.data.stats.content.pending || 0,
        icon: 'glasses-outline',
        url: 'content/items?statuses[]=pending&page=1'
      }
    ]
  }

  get contentItemColumn() {
    return getContentItemColumnsInPanel(false)
  }

  get lastCampaignsColumns() {
    return getLastCampaignsTableColumns()
  }

  get ticketsColumn() {
    return getTicketDashboardTableColumn()
  }

  get checkHasStats() {
    return (!this.isEmpty(this.dashboard_stats.data.stats.content))
  }

  //Watcher-------------------
  setCampaignTable() {
    if (this.contentItemData.length) {
      this.items = this.contentItemUseCase.data
    } else {
      this.itemsLoading = true
      this.contentItemUseCase.execute().then(() => {
        this.contentItemData = this.contentItemUseCase.data.data
        this.items = this.contentItemUseCase.data
        this.itemsLoading = false
      })
    }
  }

  @Watch('store.itemsUpdate')
  onChangeStatus() {
    this.itemsLoading = true
    this.contentItemUseCase.execute().then(() => {
      this.contentItemData = this.contentItemUseCase.data.data
      this.items = this.contentItemUseCase.data
      this.itemsLoading = false
    })
  }

  //methods------------
  allCampaigns() {
    this.campaignsLoading = true
    return this.dashboardUseCase.allCampaigns()
      .then(response => response.json())
      .then(response => {
        this.lastCampaigns = response
        this.campaignsLoading = false
      })
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0
  }

}

